export default {
  DEFAULT: 'light'
}
